// import { SessionDataType } from "../types";
import { Session } from "../__generated__/graphql";
import { CompanySubscription } from "../__generated__/graphql";
export type SessionDataType = Session | null;

export function orderBySessionsRun(data: any) {
    return [...(data ?? [])].sort(
        (a, b) => b.totalCompleteSessions - a.totalCompleteSessions
    );
}

export function countTypeOfSession({ sessionStatus, sessions }: { sessionStatus: string, sessions: SessionDataType[] }) {
    const flaggedCrisesCount = sessions
        .map(x => x?.data ? JSON.parse(x?.data)?.tags?.risk : null)
        .filter(Boolean)
        .flat()
        .filter(x => x === "Suicidality");   // removes null, undefined, false, "", 0

    // console.log(JSON.parse(sessionFlags)?.tags)
    switch (sessionStatus) {
        case "Complete":
            return sessions.filter((x) => x?.status === "Complete" && x?.checkpoint?.current?.name === "AdventureComplete")
        case "Partial":
            return sessions.filter((x) => x?.status === "Complete" && x?.checkpoint?.current?.name !== "AdventureComplete")
        case "Unusable":
            return sessions.filter((x) => x?.status === "Unusable")
        case "Local":
            return sessions.filter((x) => x?.status === "Complete" && x?.category === "Local")
        case "Remote":
            return sessions.filter((x) => x?.status === "Complete" && x?.category === "Remote")
        case "TweenScreen":
            return sessions.filter((x) => x?.status === "Complete" && x?.type === "TweenScreen")
        case "tScreen":
            return sessions.filter((x) => x?.status === "Complete" && x?.type === "tScreen")
        case "Crises":
            return flaggedCrisesCount
        default:
            return sessions
    }
}

export function getEarliestSubStart(sessionSubs: CompanySubscription[]) {
    const sortedByStart = [...(sessionSubs ?? [])].sort(
        (a, b) => a.startDate - b.startDate
    );

    return sortedByStart[0];

}

export function getLatestSubStart(sessionSubs: CompanySubscription[]) {
    const sortedByEnd = [...(sessionSubs ?? [])].sort(
        (a, b) => b.endDate - a.endDate
    );
    return sortedByEnd[0];
}

export function getYearsBetweenDates(startYear: number, endYear: number) {
    const years = [];
    for (let y = startYear; y <= endYear; y++) {
        years.push(y);
    }
    return years
}